<template>
  <div v-if="showSuccessPage">
    <dividends-page-success></dividends-page-success>
  </div>
  <div v-else class="dividends-page">
    <form>
    <div @click="backToSale()" class="dividends-page__header">
      <div class="dividends-page__back">
        <md-icon class="detail-row__clipboard-icon md-primary md-size-15">keyboard_arrow_left</md-icon>
        {{ i18n.lbl_back_to_sale() }}
      </div>
      <div class="container-header create-sale__heading">
        <div class="container-header__title">{{ i18n.lbl_dividends_pay() }}</div>
      </div>
    </div>
    <div class="dividends-page__content dividends container container_30">
      <div class="dividends-row dividends-row__main-info">
        <div class="dividends-row__name">
          <div class="dividends-row__title">{{ i18n.divid_fund_name() }}</div>
          <div class="dividends-row__value">{{ sale.name }}</div>
        </div>
        <div class="dividends-row__tokens">
          <div class="dividends-row__title">{{ i18n.divid_tokens_issued() }}</div>
          <div class="dividends-row__value">{{ sale.baseHardCap }} {{ sale.baseAsset }}</div>
        </div>
        <div class="dividends-row__investments" :class="sale.details.internal_type === 'deposit' ? 'dividends-row__investments_short' : ''">
          <div class="dividends-row__title">{{ i18n.divid_total_investments() }}</div>
          <div class="dividends-row__value">€ {{ roundCurrency(sale.currentCap, sale.defaultQuoteAsset) }}</div>
        </div>
        <div v-if="sale.details.internal_type === 'deposit'" class="dividends-row__term">
          <div class="dividends-row__title">{{ i18n.sale_campaign_duration() }}</div>
          <div class="dividends-row__value">{{ sale.details.loan_term }} {{ term }}</div>
        </div>
      </div>
      <div v-if="sale.details.internal_type === 'equity'" class="dividends-row dividends-row__payments">
        <div class="dividends-row__title">{{ i18n.divid_total_payments() }}</div>
        <div class="field-wrap">
          <input-field v-model="form.total_payments"
                       v-validate="'required'"
                       class="field_medium-small field__number"
                       :class="balanceError ? 'md-invalid' : ''"
                       name="total-payments"
                       placeholder="0"
                       id="total-payments"
                       type="number"
          />
          <div class="field-icon">€</div>
          <div v-if="balanceError" class="field-wrap__error">{{ i18n.tx_greater_than_balance()}}</div>
        </div>
        <div class="description-block">
          <md-icon md-src="/static/img/info_icon.svg" class="description-block__icon"/>
          <div>
            <div class="description-block__text">{{ i18n.divid_payments_description() }}</div>
          </div>
        </div>
      </div>
      <div class="dividends-row investors">
        <div class="dividends-row__title">{{ i18n.divid_investors_list() }}</div>
        <div class="investors__row-titles">
          <div class="investors__row-title title-email">{{ i18n.lbl_email_2() }}</div>
          <div class="investors__row-title title-tokens">{{ i18n.lbl_tokens_assets() }}</div>
          <div class="investors__row-title title-dividends">{{ i18n.divid_to_pay() }}</div>
        </div>
      </div>
      <div class="dividends-row dividends-row__investors-list investors-list md-scrollbar">
        <div v-for="item in ownersList" class="investors-list__row">
          <div class="investors-list__email">{{ item.email }}</div>
          <div class="investors-list__tokens">{{ item.amount / 1000000 }}</div>
          <div class="investors-list__dividends">€ {{ calculate(item.amount) }}</div>
        </div>
      </div>
      <div class="dividends-row dividends-row__footer">
        <div class="footer-values">
          <div class="footer-values__item">
            <span class="footer-values__text">{{ i18n.divid_total_pay() }}</span>
            <span class="footer-values__value total">€ {{ roundCurrency(payoutAmount, sale.defaultQuoteAsset) }}</span>
          </div>
          <div class="footer-values__item">
            <span class="footer-values__text">{{ i18n.divid_your_balance() }}</span>
            <span class="footer-values__value balance"> € {{ roundCurrency(currentBalance, sale.defaultQuoteAsset) }}</span>
          </div>
        </div>
        <div class="btn-wrap">
          <md-button @click="showPopupMain()" class="btn md-primary" :disabled="balanceError">{{ i18n.divid_pay_btn() }}</md-button>
        </div>
        <div class="description-block">
          <md-icon md-src="/static/img/info_icon.svg" class="description-block__icon"/>
          <div>
            <div class="description-block__text">{{ i18n.divid_footer_description() }}</div>
          </div>
        </div>
      </div>
    </div>
    <main-popup
      v-if="showPopup"
      @close-popup="closePopup"
      @submit-popup-event="submitDividendsHandle()"
      :showPopup="showPopup"
      :closeByClick="false"
      :confirmAction="true"
      :cancelAction="true"
      :actionsText="{
                     confirm: i18n.lbl_accept(),
                     cancel: i18n.lbl_cancel()
      }"
      :title="i18n.divid_accept_pay()"
      :subTitle="i18n.divid_will_debited({amount: this.roundCurrency(this.payoutAmount, this.sale.defaultQuoteAsset), currency: '€'})"
      :text="i18n.divid_can_search()"
      :disabled="isLoading"
    />
    </form>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { transferService } from '@api/transfers.service'
  import { commonEvents } from '@js/events/common_events'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { i18n } from '@js/i18n'

  import InputField from '@com/fields/InputField'
  import MainPopup from '@com/popups/PopupMain'
  import DividendsPageSuccess from './DividendsPageSuccess'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import {errors} from '@js/errors/factory'

export default {
    name: 'dividends-page',
    mixins: [CurrencyRound],
    components: {
      InputField,
      MainPopup,
      DividendsPageSuccess
    },
    props: ['sale'],
    data: _ => ({
      form: {
        total_payments: ''
      },
      showPopup: false,
      showSuccessPage: false,
      currentBalance: '',
      balanceError: false,
      isLoading: false,
      payoutAmount: 0,
      term: '',
      i18n
    }),
    computed: {
      ...mapGetters([
        vuexTypes.accountBalances,
        vuexTypes.accountId,
        vuexTypes.ownersList,
        vuexTypes.factorData
      ]),
      tokenAmount () {
        return this.ownersList.reduce((sum, item) => {
          return Number(sum) + Number(item.amount)
        }, 0)
      }
    },
    created () {
      this.currentBalance = this.accountBalances[this.sale.defaultQuoteAsset].balance
      const filter = {
        asset: this.sale.baseAsset,
        accountId: this.accountId
      }
      this.getListOwners(filter)

      if (this.form.total_payments && this.sale.details.internal_type === 'equity') {
        this.payoutAmount = this.form.total_payments
      } else if (this.sale.details.internal_type === 'deposit') {
        this.payoutAmount = +this.sale.currentCap + (+this.sale.currentCap * +this.sale.annualPercentage / 100)
        console.log(this.payoutAmount)
      }
      this.payoutAmount = Math.round(this.payoutAmount * 100000000) / 100000000
      this.term = this.getMonth(this.sale.details.loan_term)
    },
    methods: {
      ...mapActions({
        getListOwners: vuexTypes.GET_LIST_OWNERS,
        updateTwoFactorData: vuexTypes.SET_TWO_FACTOR_STATE
      }),
      backToSale () {
        this.$emit(commonEvents.dividendsPageStatus, false)
      },
      closePopup (status) {
        this.showPopup = status
      },
      showPopupMain () {
        this.showPopup = true
      },
      calculate (summ) {
        return ((Math.round(this.payoutAmount * 100 / this.tokenAmount * summ)) / 100).toString()
      },
      getMonth (el) {
        let last = el.toString().slice(-1)
        if (+last === 1) {
          return i18n.lbl_month()
        } else if (+last > 1 && +last < 5) {
          return i18n.lbl_months()
        } else {
          return i18n.lbl_months_2()
        }
      },

      async submitDividendsHandle () {
        this.isLoading = true

        let arr = []
        for (let i in this.ownersList) {
          arr.push({
            sourceBalanceId: this.accountBalances[this.sale.defaultQuoteAsset].balance_id,
            destinationAccountId: this.ownersList[i].account_id,
            amount: this.calculate(this.ownersList[i].amount),
            feeData: {
              sourceFee: {
                maxPaymentFee: '0.000000',
                fixedFee: '0.000000',
                feeAsset: this.sale.defaultQuoteAsset
              },
              destinationFee: {
                maxPaymentFee: '0.000000',
                fixedFee: '0.000000',
                feeAsset: this.sale.defaultQuoteAsset
              }
            },
            sourcePaysForDest: false,
            subject: i18n.divid_pay_subject({name: this.sale.name})
          })
        }

        try {
          await transferService.createMassTransfer(arr)
          EventDispatcher.dispatchShowSuccessEvent(i18n.tr_successful())
          this.showSuccessPage = true
          this.isLoading = false
        } catch (error) {
          if (error instanceof errors.TFAExceededCodeError) {
            EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
          } else {
            EventDispatcher.dispatchShowErrorEvent(i18n.divid_pay_error())
          }

          this.isLoading = false
          this.showPopup = false
        }
      }
    },
    watch: {
      'form.total_payments' () {
        this.balanceError = this.roundCurrency(this.form.total_payments, this.sale.defaultQuoteAsset) > +this.currentBalance
        this.payoutAmount = this.form.total_payments
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~scss/mixins";
  @import "~scss/variables";

  .dividends-page {
    &__back {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 15px;
      color: $col-md-primary;
      font-size: 16px;
      line-height: 120%;
      cursor: pointer;

      & i {
        margin: 0;
      }
    }

    &__content {
      color: $col-text-bright;
      & .dividends-row {
        margin-bottom: 18px;
        font-size: 16px;
        line-height: 150%;
        &__main-info {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        &__payments {
          border-top: 1px solid $col-border;
          & .dividends-row__title {
            margin: 0;
          }

          & > .field-wrap > .md-field{
            border-color: $col-text-bright !important;
          }
        }
        &__investors-list {
          max-height: 330px;
          border-radius: 0;
          border-top: 1px solid $col-border;
          border-bottom: 1px solid $col-border;
          overflow: auto;
        }
        &__footer {
          padding-top: 0;
        }
        &__title {
          margin-bottom: 10px;
        }
        &__value {
          color: $col-md-primary;
          font-weight: 600;
        }
        &__name {
          flex: 1 1 50%;
        }
        &__tokens {
          flex: 1 1 50%;
        }
        &__investments {
          flex: 1 1 100%;
          margin-top: 30px;
          &_short {
            flex: 1 1 50%;
          }
        }
        &__term {
          flex: 1 1 50%;
          margin-top: 30px;
        }
        &__btn-wrap {
          margin: 40px 0 30px;
        }
      }
    }
    & .investors {
      &__row-titles {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: $col-text-secondary;
        /*&:after {
          content: '';
          display: block;
          border-bottom: 1px solid rgba(203, 226, 230, 0.5);
          width: calc(100% + 60px);
          position: absolute;
          bottom: 0;
          left: -30px;
        }*/
      }
      &__row-title {
        padding-right: 10px;
      }
      & .title-email {
        flex: 0 0 300px;
      }
      & .title-tokens {
        flex: 0 0 200px;
      }
      & .title-dividends {
        flex: 1 1 auto;
      }
    }

    & .investors-list {
      &__row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 55px;
      }
      &__email {
        flex: 0 0 300px;
      }
      &__tokens {
        flex: 0 0 200px;
        font-weight: 600;
      }
      &__dividends {
        flex: 1 1 auto;
        font-weight: 600;
      }
    }

    & .footer-values {
      &__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
      }
      &__text {
        flex: 0 0 500px;
        font-size: 18px;
        line-height: 27px;
        font-weight: 600;
      }
      &__value {
        flex: 1 1 auto;
        font-size: 20px;
        line-height: 29px;
        font-weight: 600;
        &.total{
          color: $col-text-bright;
        }
        &.balance {
          color: $col-md-primary;
        }
      }
    }

    & .field-wrap__error {
      position: absolute;
      top: auto;
      bottom: 2px;
      left: 0;
      color: $col-invalid;
      font-size: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/components/Sales.DividendsPage.vue